export const forums = {
  forumsSearchInputPlaceholder: 'Поиск',
  forumsFollowDiscussionButtonTitle: 'Следить',
  forumsFollowingDiscussButtonTitle: 'Следите',
  forumDiscussionInfoNoReplyText: 'Нет ответов',
  forumsDiscussionDetailsStartButtonTitle: 'Создать дискуссию',
  forumDetailsCreatedByText: 'от',
  forumsDiscussionDetailsUsersCurtainCopyOptionTitle: 'Скопировать ссылку',
  forumsDiscussionDetailsUsersCurtainFlagOptionTitle: 'Пожаловаться',
  forumsReportedCurtainContent: 'Жалоба отправлена',
  forumsDiscussionDetailsUserCurtainCopiedAlertText: 'Ссылка скопирована!',
  forumsDiscussionDetailsOwnersCurtainPinOptionTitle: 'Закрепить дискуссию',
  forumsDiscussionDetailsOwnersCurtainUnpinOptionTitle: 'Открепить дискуссию',
  forumsDiscussionDetailsOwnersCurtainEditOptionTitle: 'Редактировать дискуссию',
  forumsDiscussionDetailsOwnersCurtainDeleteOptionTitle: 'Удалить дискуссию',
  forumsDiscussionDetailspPopupDeleteTitle: 'Удаление',
  forumsDiscussionDetailspPopupDeleteText: 'Удалить эту дискуссию?',
  forumsDiscussionDetailspPopupCancelButtonTitle: 'Отменить',
  forumsDiscussionDetailspPopupConfirmButtonTitle: 'Подтвердить',
  forumsDiscussionDetailsDeleledAlertText: 'Дискуссия удалена!',
  forumsNewDiscussionTitle: 'Новая дискуссия',
  forumsNewDiscussionTitlePlaceholder: 'Название…',
  forumsNewDiscussionBodyPlaceholderText: 'Текст дискуссии…',
  forumsNewDiscussionPublishButtonTitle: 'Опубликовать',
  forumsNewDiscussionLocationCurtainTitle: 'Локация',
  forumsNewDiscussionLocationCurtainInputPlaceholder: 'Название локации',
  forumsNewDiscussionEditLocationCurtainText: 'Редактировать локацию',
  forumsNewDiscussionDeleteLocationCurtainText: 'Удалить локацию',
  forumsNewDiscussionCreatePollTitle: 'Создать опрос',
  forumsNewDiscussionTitleInputPlaceholder: 'Название',
  forumsNewDiscussionOptionInputPlaceholder: 'Вариант',
  forumsNewDiscussionAddButtonTitle: 'Добавить вариант',
  forumsNewDiscussionCreateButtonTitle: 'Создать',
  forumsNewDiscussionPollTitleBlankAlertText: 'Заполните поле',
  forumsNewDiscussionPollOptionBlankAlertText: 'Заполните поле',
  forumsNewDiscussionPollLongTitleAlertText: 'Слишком длинное название, выберите не больше 140 символов',
  forumsNewDiscussionPollLongOptionAlertText: 'Слишком длинный вариант, выберите не больше 25 символов',
  forumsNewDiscussionEditPollIconText: 'Редактировать опрос',
  forumsNewDiscussionRemovePollIconText: 'Удалить опрос',
  forumsDiscardDraftPopupTitle: 'Черновик',
  forumsDiscardDraftPopupText: 'Удалить этот черновик?',
  forumsDiscardDraftPopupCancelButtonTitle: 'Отменить',
  forumsDiscardDraftPopupConfirmButtonTitle: 'Подтвердить',
  forumsDiscussionDetailsPostBodyReplyIconTitle: 'Ответить',
  forumsDiscussionDetailsNoCommentsText: 'Нет комментариев\nОставьте первый комментарий',
  forumsDiscussionDetailsReplyInputPlaceholder: 'Ответить',
  forumsDiscussionDetailsPostShareCurtainOptionTitle: 'Скопировать ссылку',
  forumsDiscussionDetailsPostShareCopiedAlertText: 'Ссылка скопирована!',
  forumsDiscussionDetailsPostUsersCurtainFlagOptionTitle: 'Пожаловаться',
  forumsDiscussionDetailsPostCurtainReportedText: 'Жалоба отправлена',
  forumsDiscussionDetailsCommentReplyIconTitle: 'Ответить',
  forumsEditDiscussionTitle: 'Редактировать дискуссию',
  forumsEditDiscussionSaveButtonTitle: 'Сохранить',
  forumsEditedDiscussionSavedAlertText: 'Дискуссия сохранена!',
  forumsDiscussionDetailsOwnersCommentCurtainEditOptionTitle: 'Редактировать ответ',
  forumsDiscussionDetailsOwnersCommentCurtainDeleteOptionTitle: 'Удалить ответ',
  forumsDiscussionDetailsEditedCommSavedAlertText: 'Комментарий сохранен!',
  forumsDiscussionDetailsEditedCommDeletedAlertText: 'Комментарий удален!',
  forumsAlertSomethinWrong: 'Что-то пошло не так!',
  forumsMaxMbSize: 'Вы не можете загрузить больше {size} МБ за один раз',
  forumsMaxAttachments: 'Вы превысили максимальное количество фотографий. Максимальное количество — {max} фото',
  forumsDiscussionDetailsDeleteCommentPopupTitle: 'Удаление',
  forumsDiscussionDetailsDeleteCommentPopupText: 'Удалить этот комментарий?',
  forumsDiscussionDetailsDeleteCommentPopupCancelButtonTitle: 'Отменить',
  forumsDiscussionDetailsDeleteCommentPopupConfirmlButtonTitle: 'Подтвердить',
  forumsDiscussionDetailsUsersCommentCurtainFlagOptionTitle: 'Пожаловаться',
  forumsDiscussionDetailsCommentReportedCurtainText: 'Жалоба отправлена',
  forumDiscussionInfoLastReplyText: 'Последний ответ',
  forumsDiscussionAt: 'в',
  forumsDiscussionDetailsFlagCurtainTitle: 'Пожаловаться',
  forumsDiscussionDetailsFlaggedReportedCurtainContent: 'Жалоба отправлена',
  forumsPollInfoVotesText: 'голосов',
  forumsPollInfoEditVoteText: 'Переголосовать',
  forumsPollFinishPollText: 'Завершить',
  forumsPollFinishedPollText: 'Завершено',
  forumsPollInProgresslText: 'В процессе',
  forumsPollCurtainTitle: 'Завершить',
  forumsPollCurtainText: 'Пользователи больше не смогут голосовать в этом опросе, когда он будет завершен.',
  forumsFinishPollCurtainCancelButtonTitle: 'Отменить',
  forumsFinishPollCurtainConfirmlButtonTitle: 'Подтвердить',
  forumsPollInfoPollVotesCurtainTitle: 'Голоса'
}
